import { Tabs, Divider } from 'antd';
import constants from '../../constants/constants';
import { StockOutlined, BarChartOutlined, ProfileOutlined } from '@ant-design/icons';
import Analysis from './Analysis';
import AnalysisReport from './AnalysisReports';
import ReportHistory from './ReportHistory';
import AnalysisTest from './AnalysisTest';
import Cookies from 'js-cookie';
const { TabPane } = Tabs;

const AnalysisContainer = () => {
  const isSuperAdmin = Cookies.get(constants.COOKIE_IS_SUPERADMIN) === 'true';

	//Render
	return (
		<div>
      <div className='uppercase font-bold text-xl'>Analysis</div>
			<Divider className='my-3'/>
      <Tabs defaultActiveKey="1" destroyOnHidden={true}>
       {isSuperAdmin && (
        <TabPane
          tab={<span className='uppercase'><StockOutlined className='text-xl' />{constants.AnalysisTab1} Test</span>}
          key={4}
        >
          <AnalysisTest />
        </TabPane>
      )}
			<TabPane
        tab={ <span className='uppercase'><StockOutlined className='text-xl' />{constants.AnalysisTab1}</span> }
        key={1}
      >
       <Analysis/>
      </TabPane>
			<TabPane
        tab={ <span className='uppercase'><BarChartOutlined className='text-xl' />{constants.AnalysisTab2}</span> }
        key={2}
      >
        <AnalysisReport/>
      </TabPane>
      <TabPane
        tab={<span className='uppercase'><ProfileOutlined className='text-xl' />{constants.AnalysisTab3}</span>}
        key={3}
      >
        <ReportHistory />
      </TabPane>
			</Tabs>
		</div>
	);
};

export default AnalysisContainer;